import vtkStateBuilder from '@kitware/vtk.js/Widgets/Core/StateBuilder';
import vtkWidgetState from '@kitware/vtk.js/Widgets/Core/WidgetState';

export interface CurvedMPRWidgetState extends vtkWidgetState {
  /** True while the user is dragging an existing handle. */
  setDragging(dragging: boolean): boolean;
  getDragging(): boolean;

  /**
   * Index of the handle currently being dragged, or -1 if none.
   * We don't allocate sub-states for handles — the points list lives in the
   * Pinia store, and the widget invokes callbacks to mutate it.
   */
  setActiveIndex(index: number): boolean;
  getActiveIndex(): number;
}

export default function generateState() {
  return vtkStateBuilder
    .createBuilder()
    .addField({
      name: 'dragging',
      initialValue: false,
    })
    .addField({
      name: 'activeIndex',
      initialValue: -1,
    })
    .build();
}
